import React from 'react';
import styles from './index.css';
import { formatImage } from '../../../../../../base/publicMethod/index';
import 'intersection-observer';
import { Player } from '../../../../../../mobile/video';
import LazyLoad from '@ifeng-fe/ui_pc_lazyLoad';

const EmptyBox = () => {
    const documentWidth = document.documentElement.clientWidth || document.body.clientWidth;
    const videoWidth = (documentWidth > 812 ? 812 : documentWidth) - ((30 * documentWidth) / 750) * 2;
    const videoHeight = Math.floor((videoWidth * 9) / 16);

    return <div style={{ width: videoWidth, height: videoHeight }} />;
};

class ShortPlayer extends React.PureComponent {
    render() {
        const { content } = this.props;
        const documentWidth = document.documentElement.clientWidth || document.body.clientWidth;
        const videoWidth = (documentWidth > 812 ? 812 : documentWidth) - ((30 * documentWidth) / 750) * 2;
        const videoHeight = Math.floor((videoWidth * 9) / 16);

        const postImg =
            (content.thumbnails &&
                content.thumbnails.image &&
                content.thumbnails.image[0] &&
                content.thumbnails.image[0].url &&
                content.thumbnails.image[0].url.replace(/\.webp|_webp/g, '')) ||
            (content.thumbnail && content.thumbnail.replace(/\.webp|_webp/g, '')) ||
            '';

        const videoConfig = {
            mobileUrl: content.videoPlayUrl,
            bigPosterUrl: postImg,
        };

        const playermsg = {
            auth: true,
            showTitle: true,
            showPoster: true,
            showController: true,
            m3u8Play: true,
            pauseAfterLeave: true,
            height: videoHeight,
            width: videoWidth,
        };

        return (
            <div className={styles.box}>
                <LazyLoad placeholder={EmptyBox}>
                    <Player videoConfig={videoConfig} playermsg={playermsg} />
                </LazyLoad>
            </div>
        );
    }
}

export default ShortPlayer;
